

import React from 'react'
import ReduxStores from '../../../../stores/connects'
import BookingsDropdown from '../homepage/bookingsDropdown.jsx'
import SearchForm from '../searchForm.jsx'
import { object, string, bool } from 'prop-types'
import defaultFooterConfig from '../../../../config/navigation/footer/uk/'

class FooterLogic extends React.Component {
  /**
    Get the footer config in props or defaults

    @returns object - config
  */
  getFooterConfig () {
    return this.props.footerConfig ? this.props.footerConfig : defaultFooterConfig
  }

  generateLoginLink () {
    const { pageName, domainSettings } = this.props
    const { customerLoginLocation } = this.props.getLoginConfig()
    let referrerLink = ''
    if (domainSettings.domain) {
      referrerLink += (domainSettings.domainScheme ? domainSettings.domainScheme : 'http') + '://'
      referrerLink += domainSettings.domain
    }
    if (pageName) {
      const isHomepage = pageName === 'index' || pageName === 'index-2' || pageName === 'index-3'
      if (!isHomepage) referrerLink += '/' + pageName
      if (!isHomepage && !pageName.match('.html')) referrerLink += '.html'
    }
    if (!referrerLink) return customerLoginLocation
    return customerLoginLocation + '?referrer=' + referrerLink
  }

  /**
    Checks if the login is meant to be a link or a dropdown

    @returns markup - the appropriate link/dropdown
  */
  getLoginButton () {
    const { header, agentLoginLocation, agentCallToAction, customerTitle, isLoginLink } = this.props.getLoginConfig()
    const customerLoginLink = this.generateLoginLink()

    if (!isLoginLink) {
      return (
        <li className='bg-mute'>
          <a className='collapse-heading collapsed' data-toggle='collapse' data-target='#loginContainer'>
            <span className='symbol collapse-icon visible-xs-inline-block visible-sm-inline-block'>&gt;</span>{ header }
          </a>
          <div id='loginContainer' className='collapse-xs container links-list'>
            <span className='show'><a data-hxtrack-name='agent_login_footer' href={agentLoginLocation}>{agentCallToAction}</a></span>
            <span className='show'><a data-hxtrack-name='login_footer_click' href={customerLoginLink} title='Your Account'>{customerTitle}</a></span>
          </div>
        </li>
      )
    }
    // defaults to returning a link
    return (
      <li className='bg-mute'>
        <a className='collapse-heading' href={agentLoginLocation}>
          { header }
        </a>
      </li>
    )
  }

  render () {
    const { loggedInData, loggedInData: { bookingHistory: { bookings } }, hideSearch } = this.props
    const { formSettings, dataSource } = this.props
    const footerConfig = this.getFooterConfig()

    return (
      <div id='footerLogin' className='bg-default visible-xs visible-sm block-sm'>
        <div className='container'>
          <div className='col-sm-5 row'>
            <ul className='nav nav-stacked lead'>
              {!hideSearch && (
                <li className='bg-mute'>
                  <SearchForm
                    id='footer-search'
                    searchFormPlaceholder={footerConfig.linksBar.search}
                    searchButtonText={footerConfig.linksBar.searchPlaceholder}
                    searchFormAction={footerConfig.linksBar.searchPath}
                  />
                </li>
              )}
              { loggedInData && loggedInData.first_name && bookings.length ? (
                <li className='bg-mute'>
                  <a className='collapse-heading collapsed' data-toggle='collapse' data-target='#manageMyBookingContainer'>
                    <span className='symbol collapse-icon visible-xs-inline-block visible-sm-inline-block'>&gt;</span>Manage my booking
                  </a>
                  <div id='manageMyBookingContainer' className='collapse-xs container'>
                    <BookingsDropdown
                      message=''
                      messageClass='lead'
                      formSettings={formSettings}
                      dataSource={dataSource}
                      customClass='btn-block footer-bookings'
                    />
                  </div>
                </li>
              ) : this.getLoginButton() }
            </ul>
          </div>
        </div>
      </div>
    )
  }
}

FooterLogic.propTypes = {
  dataSource: object,
  formSettings: object,
  domainSettings: object,
  pageName: string,
  footerConfig: object,
  hideSearch: bool
}
FooterLogic.defaultProps = {
  domainSettings: { },
  loggedInData: { bookingHistory: { } },
  getLoginConfig: () => { return { } },
  hideSearch: false
}

export default ReduxStores(FooterLogic, ['login'], true)
